var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-card card-dashboard"},[_c('h1',[_vm._v(_vm._s(_vm.slide.title))]),_c('DashboardTrack',{on:{"swiperUpdate":_vm.swiperUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }